export default {
	custom : {
		email : {
			required : 'El campo email es obligatorio',
			email : 'Debes indicar una dirección de correo electrónico válida'
		},
		password :{
			required : 'El campo contraseña es obligatorio'
		},	
		perfil_digital : {
			url : 'Está mal formado',
		},
		idioma : {
			required : 'Este campo es obligatorio'
		},
		nivel : {
			required : 'Este campo es obligatorio'
		},
		otro_idioma : {
			required : 'Este campo es obligatorio'
		},
		tipodocumento : {
			required : 'Este campo es obligatorio'
		},
		nombredoc : {
			required : 'Este campo es obligatorio'
		},
		puesto : {
			required : 'Este campo es obligatorio'
		},
		empresa : {
			required : 'Este campo es obligatorio'
		},
		sector : {
			required : 'Este campo es obligatorio'
		},
		ubicacion : {
			required : 'Este campo es obligatorio'
		},
		funcion : {
			required : 'Este campo es obligatorio'
		},
		fechainicio : {
			required : 'Este campo es obligatorio'
		},
		fechafin : {
			required : 'Este campo es obligatorio'
		},
		titulo : {
			required : 'Este campo es obligatorio'
		},
		ambito : {
			required : 'Este campo es obligatorio'
		},
		especialidad : {
			required : 'Este campo es obligatorio'
		},
		centro : {
			required : 'Este campo es obligatorio'
		},
		nota : {
			required : 'Este campo es obligatorio'
		},
		resumen : {
			max : 'La longitud máxima son 800 caracteres'
		},
		telefono : {
			required : 'Este campo es obligatorio'
		},
		movil : {
			required : 'Este campo es obligatorio'
		},
		direccion : {
			required : 'Este campo es obligatorio'
		},
		ciudad : {
			required : 'Este campo es obligatorio'
		},
		CP : {
			required : 'Este campo es obligatorio'
		},
		paisresidencia : {
			required : 'Este campo es obligatorio'
		},
		provincia : {
			required : 'Este campo es obligatorio'
		},
		docfile : {
			required : 'Debes adjuntar un fichero',
			mimes : 'Esta extensión no es apta',
			size : 'El tamaño debe ser inferior a 1.5MB'
		}
	}
}


// WEBPACK FOOTER //
// ./src/validator/es.js